import React, { createContext, useContext, useEffect, useState } from "react";
import { api, setToken, clearToken, getToken, apiError } from "@/lib/api";

type User = { id: string; email: string; name: string; role: string; mfa_enabled?: boolean };
type AuthCtx = {
  user: User | null | undefined; // undefined = checking
  login: (email: string, password: string) => Promise<void>;
  logout: () => void;
};

const Ctx = createContext<AuthCtx>({} as AuthCtx);
export const useAuth = () => useContext(Ctx);

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [user, setUser] = useState<User | null | undefined>(undefined);

  useEffect(() => {
    if (!getToken()) {
      setUser(null);
      return;
    }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => { clearToken(); setUser(null); });
  }, []);

  const login = async (email: string, password: string) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setToken(data.access_token);
      setUser(data.user);
    } catch (e: any) {
      throw new Error(apiError(e.response?.data?.detail) || "Login failed");
    }
  };

  const logout = () => {
    api.post("/auth/logout").catch(() => {});
    clearToken();
    setUser(null);
  };

  return <Ctx.Provider value={{ user, login, logout }}>{children}</Ctx.Provider>;
}
